export const refreshPage = () => {
    let pageUrl = new URL(window.location.href);
    window.location.replace(pageUrl.href);
  };